<div class="form-group">
    <label class="input-label">Earlier than:</label>
    <input class="form-control"
           name="minRows"
           type="date"
           value="{{fieldOptions.validate.earlierThan}}"
           [(ngModel)]="fieldOptions.validate.earlierThan">
</div>